import { render } from "./DemoView.vue?vue&type=template&id=8ad35076&scoped=true"
import script from "./DemoView.vue?vue&type=script&lang=js"
export * from "./DemoView.vue?vue&type=script&lang=js"

import "./DemoView.vue?vue&type=style&index=0&id=8ad35076&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8ad35076"]])

export default __exports__